module.exports = __webpack_public_path__ + "static/media/lds-logo_sl.8fb91302.svg";